<template>
    <component
        :is="props.expired ? 'button' : 'div'"
        :type="props.expired ? 'button' : undefined"
        data-test="message-attachment"
        class="appearance-none max-w-full inline-flex flex-col border border-solid px-1"
        :class="[colors.container, props.expired ? 'cursor-pointer' : '']"
    >
        <span v-if="props.hasPreview" data-test="message-attachment-preview" class="p-1.5 pb-0">
            <slot></slot>
        </span>
        <span class="flex items-center gap-2 h-10 ps-3" :class="props.expired ? 'pe-4' : 'pe-1.5'">
            <font-awesome-icon widthAuto :icon="faPaperclip" class="shrink-0 text-sm" :class="colors.icon" />
            <span
                data-test="message-attachment-label"
                class="min-w-0 flex-1 truncate text-sm text-start"
                :class="colors.label"
            >
                {{ props.expired ? 'Media Expired' : props.label }}
            </span>
            <vx-button
                v-if="!props.expired"
                color="transparent"
                size="xs"
                :href="props.mediaUrl"
                target="_blank"
                rel="noopener noreferrer"
                data-test="message-attachment-download"
            >
                Download
                <font-awesome-icon widthAuto :icon="faDownload" class="text-xs" />
            </vx-button>
        </span>
    </component>
</template>

<script lang="ts" setup>
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';
import { computed } from 'vue';

const COLORS = {
    outbound: {
        container: 'bg-sky-100 border-sky-200 rounded-l-lg rounded-tr-lg rounded-br-sm',
        icon: 'text-sky-500',
        label: 'text-sky-800',
    },
    inbound: {
        container: 'bg-slate-100 border-slate-200 rounded-r-lg rounded-tl-lg rounded-sm',
        icon: 'text-slate-500',
        label: 'text-slate-700',
    },
} as const;

const props = withDefaults(
    defineProps<{
        mediaUrl?: string;
        hasPreview?: boolean;
        label: string;
        direction: 'inbound' | 'outbound';
        expired?: boolean;
    }>(),
    {
        mediaUrl: '',
        hasPreview: false,
        expired: false,
    }
);

const colors = computed(() => COLORS[props.direction]);
</script>
